import React from "react";
import "./index.css";
import Header from "../Header";
import Footer from "../Footer";
import "../Footer/index.css";
import { Link } from "react-router-dom";
// import "../../common/css/common.css";

function Landing(){
   
    return(
        <>
        <Header/>
        
        <div className="mainWrapper">
        <section className="section bannerBox section-scroll">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5">
                        <h1>Have An</h1>
                        <h1><span>Opinion?</span></h1>
                        <p>Bedater provides online platform to join debate programme and share your opinion.</p>
                        <p>Be the first one to join.</p>
                        <Link to="/event" className="btn btn-gradient">
                            <svg className="mr-3" width="16" height="24" viewBox="0 0 16 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M15.4073 6.23389C15.0814 6.23389 14.8147 6.51441 14.8147 6.85727V11.5326C14.8147 15.4911 11.7628 18.7015 7.99988 18.7015C4.23692 18.7015 1.18506 15.4911 1.18506 11.5326V6.85727C1.18506 6.51441 0.918396 6.23389 0.592471 6.23389C0.266545 6.23389 -0.00012207 6.51441 -0.00012207 6.85727V11.5326C-0.00012207 15.9586 3.25914 19.6054 7.40729 19.9171V22.7535H4.14803C3.8221 22.7535 3.55543 23.034 3.55543 23.3769C3.55543 23.7197 3.8221 24.0002 4.14803 24.0002H12.4443C12.7702 24.0002 13.0369 23.7197 13.0369 23.3769C13.0369 23.034 12.7702 22.7535 12.4443 22.7535H8.59247V19.9171C12.7406 19.6054 15.9999 15.9586 15.9999 11.5326V6.85727C15.9999 6.51441 15.7332 6.23389 15.4073 6.23389Z"
                                    fill="white" />
                                <path
                                    d="M7.99987 16.8313C10.7851 16.8313 13.0369 14.4624 13.0369 11.5325V5.29874C13.0369 2.36885 10.7851 0 7.99987 0C5.21468 0 2.96283 2.36885 2.96283 5.29874V11.5325C2.96283 14.4624 5.21468 16.8313 7.99987 16.8313ZM4.14801 10.2858H7.70357C8.0295 10.2858 8.29616 10.0053 8.29616 9.66241C8.29616 9.31955 8.0295 9.03903 7.70357 9.03903H4.14801V7.79226H7.70357C8.0295 7.79226 8.29616 7.51174 8.29616 7.16888C8.29616 6.82602 8.0295 6.5455 7.70357 6.5455H4.14801V5.29874H7.70357C8.0295 5.29874 8.29616 5.01822 8.29616 4.67536C8.29616 4.3325 8.0295 4.05198 7.70357 4.05198H4.32579C4.8295 2.43119 6.28135 1.24676 7.99987 1.24676C10.1332 1.24676 11.8517 3.05457 11.8517 5.29874V11.5325C11.8517 13.7767 10.1332 15.5845 7.99987 15.5845C5.86653 15.5845 4.14801 13.7767 4.14801 11.5325V10.2858Z"
                                    fill="white" />
                            </svg>
                            Join Event
                        </Link>
                    </div>
                    <div className="col-lg-6 offset-lg-1 pr-lg-0 right">
                        <img src={process.env.PUBLIC_URL + "/img/banner-img.png"}  className="banner-img" alt="" title="" width="559" />
                    </div>
                </div>
            </div>
        </section>

        <section className="section section-scroll aboutBox" id="aboutSection">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 left">
                        <img src={process.env.PUBLIC_URL +"img/about-image.png"} alt="" title="" width="464" />
                    </div>
                    <div className="col-lg-6">
                        <h2>About</h2>
                        <p>Bedater is a live debating platform where it will integrate the audience in the debates as
                            well.
                            With giving the ability for the crowd to vote on their preferred debater and to ask
                            questions,
                            to having the mediator let the debate run on smoothly and efficiently.</p>
                        <p className="mb-0">No longer will individuals have to stay silent when they disagree with
                            something.
                            One thing to
                            remember is as of everything debate there is always something to learn. From your opponent
                            to
                            gaining more knowledge about topics and even quite possibly yourself.</p>
                    </div>
                </div>
            </div>
        </section>

        <section className="section section-scroll howItWorksBox" id="howItWorksSection">
            <div className="top">
                <div className="container">
                    <h2>How It Works</h2>
                    <ul className="nav" id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <a className="nav-link active" id="step1-tab" data-toggle="tab" href="#step1" role="tab"
                                aria-controls="step1" aria-selected="true">
                                Choose your interest
                                <span>1</span>
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a className="nav-link" id="step2-tab" data-toggle="tab" href="#step2" role="tab"
                                aria-controls="step2" aria-selected="false">
                                Record your video
                                <span>2</span>
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a className="nav-link" id="step3-tab" data-toggle="tab" href="#step3" role="tab"
                                aria-controls="step3" aria-selected="false">
                                Join your debate
                                <span>3</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="step1" role="tabpanel" aria-labelledby="step1-tab">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6 col-lg-5 offset-lg-1">
                                <img src={process.env.PUBLIC_URL +'img/how-it-works-tab1-img.png'} alt="" title="" width="396" />
                            </div>
                            <div className="col-md-6 col-lg-5">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                    incididunt
                                    ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                    ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                <p className="mb-0">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                                    dolore
                                    eu fugiat
                                    nulla pariatur.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tab-pane fade" id="step2" role="tabpanel" aria-labelledby="step2-tab">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6 col-lg-5 offset-lg-1">
                                <img src={process.env.PUBLIC_URL +'img/how-it-works-tab1-img.png' } alt="" title="" width="396" />
                            </div>
                            <div className="col-md-6 col-lg-5">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                    incididunt
                                    ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                    ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                <p className="mb-0">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                                    dolore
                                    eu fugiat
                                    nulla pariatur.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tab-pane fade" id="step3" role="tabpanel" aria-labelledby="step3-tab">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6 col-lg-5 offset-lg-1">
                                <img src={process.env.PUBLIC_URL +'img/how-it-works-tab1-img.png'} alt="" title="" width="396" />
                            </div>
                            <div className="col-md-6 col-lg-5">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                    incididunt
                                    ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                    ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                <p className="mb-0">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                                    dolore
                                    eu fugiat
                                    nulla pariatur.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section howToUseBox section-scroll">
            <div className="container">
                <h2 className="text-center">How <span>Bedater</span> Can be Used</h2>
                <div className="row align-items-center">
                    <div className="col-md-6 col-lg-7">
                        <img src={process.env.PUBLIC_URL + 'img/how-to-use-img1.png' } width="600" alt="" title="" />
                    </div>
                    <div className="col-md-6 col-lg-5 content">
                        <h3>Schools (Clubs/ClassNamerooms)</h3>
                        <p className="mb-0">With this Bedater platform it will have students more engaged in challenging
                            each
                            other’s thoughts. Have an opinion of their own and think differently. Wether it is a
                            classNameroom
                            in a middle/high school or an after school club, It will help students gain a better skill
                            at
                            debating within each other and just might bring out the passion out of some students in
                            certain
                            topics. With the live debate platform features plus modernistic and integration added
                            within. It
                            will have everyone involved.</p>
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-md-6 col-lg-7 right">
                        <img src={process.env.PUBLIC_URL +'img/how-to-use-img2.png'} width="600" alt="" title="" />
                    </div>
                    <div className="col-md-6 col-lg-5 content">
                        <h3>Universities</h3>
                        <p className="mb-0">Wether you are majoring in any sort of field, debating ideas leads to
                            progression in
                            that field. Coming together and combating ideas potentially leading to better ones can lead
                            to
                            innovation that can be achieved within degree seeking students.
                        </p>
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-md-6 col-lg-7">
                        <img src={process.env.PUBLIC_URL +'img/how-to-use-img3.png'} width="600" alt="" title="" />
                    </div>
                    <div className="col-md-6 col-lg-5 content">
                        <h3>Events</h3>
                        <p className="mb-0">Hosting a large event where a debate will be presented, Bedater will help as
                            it’s
                            platform is perfect to engaging the audience. With just scanning the QR code or inputting
                            the
                            code provided makes it all so simple for integration. Bedater also offers a one time event
                            service as well. No need to subscribe to bedater if you only plan on using it once.</p>
                    </div>
                </div>
            </div>
        </section> 

    </div>
    <Footer/>
    
    </>
    );
}

export default Landing;
